"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _avatar = _interopRequireDefault(require("./avatar"));
// import Progress from './progress';

var previewerDemo = [{
  demo: /*#__PURE__*/_react.default.createElement(_avatar.default, null),
  key: 'default'
}];
var _default = exports.default = previewerDemo;